// actions prefixed with @@ are not meant to be handled
// see https://stackoverflow.com/questions/41305492
export const PropActions = {
  SET_PROP_VALUE: '@@prop/SET_PROP_VALUE',
};
